import type { ActivationViewCopy, Translate } from './activationViewModel.types'

export const resolveActivationViewCopy = (t: Translate): ActivationViewCopy => ({
  recoveryIntro: {
    leftEyebrow: t('customer.auth.activate.recovery.leftEyebrow'),
    leftTitle: t('customer.auth.activate.recovery.leftTitle'),
    leftSubtitle: t('customer.auth.activate.recovery.leftSubtitle'),
    nextStepsTitle: t('customer.auth.activate.recovery.nextStepsTitle'),
    nextSteps: [
      t('customer.auth.activate.recovery.nextStepOne'),
      t('customer.auth.activate.recovery.nextStepTwo'),
      t('customer.auth.activate.recovery.nextStepThree'),
    ],
    trustNote: t('customer.auth.activate.recovery.trustNote'),
    securityPanelTitle: t('customer.auth.activate.recovery.securityPanelTitle'),
    securityPanelItems: [
      t('customer.auth.activate.recovery.securityPanelItemOne'),
      t('customer.auth.activate.recovery.securityPanelItemTwo'),
      t('customer.auth.activate.recovery.securityPanelItemThree'),
    ],
  },
  setupIntro: {
    customerAreaLabel: t('common.customerArea'),
    title: t('customer.auth.activate.setupTitle'),
    subtitle: t('customer.auth.activate.setupSubtitle'),
    checklistItems: [
      t('customer.auth.activate.check.password'),
      t('customer.auth.activate.check.security'),
      t('customer.auth.activate.check.twoFactor'),
    ],
    contextNote: t('customer.auth.activate.contextNote'),
  },
  success: {
    title: t('customer.auth.activate.successTitle'),
    body: t('customer.auth.activate.successBody'),
    goToLoginLabel: t('customer.auth.activate.goToLogin'),
    goHomeLabel: t('customer.auth.signupSuccessHomeCta'),
  },
  loading: {
    title: t('customer.auth.activate.loadingTitle'),
    body: t('customer.auth.activate.loadingBody'),
  },
  recoveryView: {
    cardEyebrow: t('customer.auth.activate.recovery.cardEyebrow'),
    cardTitle: t('customer.auth.activate.recovery.cardTitle'),
    cardSubtitle: t('customer.auth.activate.recovery.cardSubtitle'),
    emailLabel: t('customer.auth.email'),
    emailPlaceholder: t('customer.auth.emailPlaceholder'),
    submitCta: t('customer.auth.activate.recovery.submitCta'),
    submittingCta: t('customer.auth.activate.recovery.submittingCta'),
    submitHint: t('customer.auth.activate.recovery.submitHint'),
    securityNote: t('customer.auth.activate.recovery.securityNote'),
    helper: t('customer.auth.activate.recovery.helper'),
    successTitle: t('customer.auth.activate.recovery.successTitle'),
    successBody: t('customer.auth.activate.recovery.successBody'),
    successHint: t('customer.auth.activate.recovery.successHint'),
    successSpamHint: t('customer.auth.activate.recovery.successSpamHint'),
    backToLoginLabel: t('customer.auth.activate.backToLogin'),
  },
  setupView: {
    customerAreaLabel: t('common.customerArea'),
    cardTitle: t('customer.auth.activate.cardTitle'),
    cardSubtitle: t('customer.auth.activate.cardSubtitle'),
    sectionPasswordTitle: t('customer.auth.activate.section.password'),
    passwordLabel: t('customer.auth.password'),
    passwordPlaceholder: t('customer.auth.passwordPlaceholder'),
    passwordShowLabel: t('customer.auth.password.show'),
    passwordHideLabel: t('customer.auth.password.hide'),
    confirmPasswordLabel: t('customer.auth.passwordConfirm'),
    confirmPasswordPlaceholder: t('customer.auth.passwordConfirmPlaceholder'),
    requirementsTitle: t('customer.auth.activate.requirementsTitle'),
    passwordValidLabel: t('customer.auth.activate.passwordValid'),
    sectionSecurityTitle: t('customer.auth.activate.section.security'),
    sectionSecuritySubtitle: t('customer.auth.activate.section.securitySubtitle'),
    sectionTwoFactorTitle: t('customer.auth.activate.section.twoFactor'),
    sectionTwoFactorSubtitle: t('customer.auth.activate.section.twoFactorSubtitle'),
    optionalBadge: t('customer.auth.activate.optionalBadge'),
    twoFactorFoundationNote: t('customer.auth.activate.twoFactor.foundationNote'),
    submitCta: t('customer.auth.activate.completeRegistrationCta'),
    submittingCta: t('customer.auth.activate.submittingCta'),
    profileSettingsNote: t('customer.auth.activate.profileSettingsNote'),
    trustFooter: t('customer.auth.activate.trustFooter'),
    backToLoginLabel: t('customer.auth.activate.backToLogin'),
  },
  submitMessages: {
    recoveryRateLimit: t('customer.auth.activate.recovery.rateLimit'),
    recoveryError: t('customer.auth.activate.recovery.error'),
    setupSubmitError: t('customer.auth.activate.submitError'),
  },
})
